import React, {useContext, useRef} from 'react';
import Header from "../components/Header/Header";
import TitleSectionSubPage from "../components/TitleSection/TitleSectionSubPage";
import VideoSection from "../components/VideoSection/VideoSection";
import Image from "next/image";
import styles from "../styles/pass.module.css"
import cn from "classnames";
import ApplicationScopeSection from "../components/ApplicationScopeSection/ApplicationScopeSection";
import Footer from "../components/Footer/Footer";
import image from '../public/pass-title-bg.png'
import {useRouter} from "next/router";
import {en} from "../locales/en";
import {ru} from "../locales/ru";
import {ModalContext} from "../components/modalLayout/ModalLayout";

const Pass = () => {
    const firstSection = useRef(null)
    const router = useRouter();
    const t: any = router.locale === 'en' ? en : ru;
    const modal = useContext(ModalContext);

    return (
        <>
            <Header firstSection={firstSection}/>
            <main>
                <TitleSectionSubPage
                    title={'Faсe2Pass'}
                    description={t.face2pass.header.subtitle}
                    boldDescription={t.face2pass.header.title}
                    firstSection={firstSection}
                    backgroundUrl={image}
                    mobileBackgroundUrl={'/pass-title-bg-sm.jpg'}
                />

                <VideoSection
                    title={t.face2pass.videoSection.description}>
                    <iframe
                        className={'main-video'}
                        src="https://www.youtube-nocookie.com/embed/KmRE-YiN3ec?modestbranding=1"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </VideoSection>

                <section className={cn('section', styles.advantageSection)}>
                    <ul className={styles.advantages}>
                        <li>
                            <div className={styles.advantagesInfoContainer}>
                                <div className={styles.advantagesInfo}>
                                    <div className={cn('section-logo-text_white', styles['section-logo-text_white'])}>
                                        Face
                                        <div className={'services__section-logo-container'}>
                                            <Image width={32} height={32} src={'/face2greenLogo.svg'}/>
                                        </div>
                                        Pass
                                    </div>
                                    <p className={'terminal-list__title'}>
                                        {t.face2pass.advantageSection.list[0].title}
                                    </p>
                                    <p className={styles.advantagesDescription}>
                                        {t.face2pass.advantageSection.list[0].text}
                                    </p>
                                </div>
                            </div>
                        </li>

                        {
                            t.face2pass.advantageSection.list &&
                            t.face2pass.advantageSection.list.slice(1, t.face2pass.advantageSection.list.length).map((item: {
                                    title: string,
                                    text: string
                                }, index: React.Key) =>
                                    <li key={index}>
                                        <div className={styles.advantagesInfoContainer}>
                                            <div className={styles.advantagesInfo}>
                                                <p className={'services__title'}>
                                                    {item.title}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                            )
                        }
                    </ul>
                </section>

                <div className={'bg-white'}>
                    <section className={cn('section-white', styles.applicationScopeSection)}>
                        <ApplicationScopeSection/>
                    </section>
                </div>

                <section className={cn('section-after-white section-sm', styles.sectionSM)}>
                    <h2 className={'section-sm__inner-wrapper'}>
                        {t.face2pass.terminal.title}
                    </h2>

                    <ul className={cn('terminal-list', styles.terminalList)}>
                        {
                            t.face2pass.terminal.list &&
                            t.face2pass.terminal.list.map((item: {
                                    title: string,
                                    text: string
                                }, index: React.Key) =>
                                    <li key={index} className={'terminal-list__item'}>
                                        <div className={'terminal-item__container'}>
                                            <p className={'terminal-list__title'}>
                                                {item.title}
                                            </p>
                                            <p className={'body-text_white'}>
                                                {item.text}
                                            </p>
                                        </div>
                                    </li>
                            )
                        }
                    </ul>
                    <p className={cn('terminal-description')}>{t.face2pass.terminal.description}</p>
                    <button
                        style={{
                            margin: '10px auto'
                        }}
                        className={"button_base"}
                        onClick={() => modal.openFormModal(true)}
                    >
                        {t.btn.consultationCost}
                    </button>
                    {/*<div className={cn('bg-white', styles.connectingCost)}>
                        <h2 className={'text-center'}>Стоимость подключения</h2>
                        <div className={styles.costCalculator}>
                            <div className={'text-input-container'}>
                                <SliderTextFieldComponent
                                    label="Зданий"
                                    marks={[
                                        {
                                            label: 'от 1',
                                            value: 1
                                        },
                                        {
                                            label: 'до 10',
                                            value: 10
                                        }
                                    ]}
                                    onChange={() => {

                                    }}
                                    width="100%"
                                    max={10}
                                    min={1}
                                />

                                <SliderTextFieldComponent
                                    label="Турникетов для входа"
                                    marks={[
                                        {
                                            label: 'от 1',
                                            value: 1
                                        },
                                        {
                                            label: 'до 50',
                                            value: 50
                                        }
                                    ]}
                                    onChange={() => {

                                    }}
                                    width="100%"
                                    max={50}
                                    min={1}
                                />

                                <SliderTextField
                                    label='Шлагбаумов для въезда автомобилей'
                                    marks={[
                                        {
                                            label: 'от 1',
                                            value: 1
                                        },
                                        {
                                            label: 'до 50',
                                            value: 50
                                        }
                                    ]}
                                    onChange={() => {

                                    }}
                                    width="100%"
                                    max={50}
                                    min={1}
                                />
                            </div>

                            <div className={styles.costInfo}>
                                <div className={styles.costPriceContainer}>
                                    <p className={'services__title'}>Ориентировочная стоимость</p>
                                    <p className={styles.costResult}>100 000 ₽</p>
                                </div>

                                <p className={styles.constDescription}>
                                    Чтобы рассчитать более точную стоимость закажите консультацию. Мы узнаем все необходимые характеристики и посчитаем стоимость
                                </p>

                                <button className={'button_base'}>
                                    Заказать консультацию
                                </button>
                            </div>
                        </div>
                    </div>*/}
                </section>

                <section className={'section'}>
                    <h2 className={'text-center'}>
                        {t.face2pass.ControlTheSystem.title}
                    </h2>
                    <p className={styles.capabilitiesDescription}>
                    {t.face2pass.ControlTheSystem.description}
                    </p>

                    <div className={styles.capabilities}>
                        <ul className={styles.capabilityList}>
                            {
                                t.face2pass.ControlTheSystem.list &&
                                t.face2pass.ControlTheSystem.list.map((item: {
                                    src: string,
                                    text: string
                                }, index: React.Key) =>
                                    <li key={index} className={styles.capabilitiesItem}>
                                        <div className={styles.capabilitiesItemImage}>
                                            <Image height={32} width={32} src={item.src}/>
                                        </div>
                                        <p className={'body-text'}>
                                            {item.text}
                                        </p>
                                    </li>
                                )
                            }
                        </ul>

                        <div className={styles.capabilityImage}>
                            <Image width={568} height={483} src={'/capabilityImage.png'}/>
                        </div>
                    </div>
                </section>
            </main>

            <div className={'bg-gray'}>
                <Footer/>
            </div>
        </>
    );
};

export default Pass;